module.exports = __webpack_public_path__ + "0b56c2ace7bc192cdabfefd91557ecbf.fbx";